import { FONT, FONT_SIZE, FONT_WEIGTH } from "constants/fontConstants";
import { NEUTRAL_COLORS } from "constants/styleConstants";
import styled from "styled-components";

export const ModalVisualizer = styled.div`
  display: flex;

  position: fixed;

  inset: 0;

  width: 100vw;
  height: 100vh;


  background-color: #000000;

  z-index: 3000;

  align-items: center;
  justify-content: center;

`;

export const ContentVisualizer = styled.div`
  display: flex;
  flex-direction: column;

  position: relative;

  width: 1366px;
  height: 100%;

  align-items: center;
  justify-content: start;

  `;

export const HeaderVisualizer = styled.div`
display: flex;
flex-direction: row;

width: calc(100% - 80px);

justify-content: end;

margin-top: 24px;

padding: 0px 40px;
`;


export const CloseVisualizer = styled.button`
  display: flex;

  align-items: center;
  justify-content: center;

  padding: 12px;

  background-color: transparent;

  border: 0;

  cursor: pointer;

  img{
    width: 24px;
    height: 24px;
  }

`;

export const InteractionVisualizerContainer = styled.div`
  display: flex;
  flex-direction: row;

  width: calc(100% - 400px);

  align-items: center;
  justify-content: end;

  margin-bottom: 16px;

  button{
    display: flex;

    align-items: center;
    justify-content: center;

    height: 40px;

    padding: 8px 16px;

    background-color: transparent;

    border: 1px solid ${NEUTRAL_COLORS.GRAY};
    border-radius: 10px;

    cursor: pointer;

    gap:16px;


    p{
      color: ${NEUTRAL_COLORS.GRAY};
      ${FONT.BODY.BODY_SMALL[500]}
    }


  }

`;

export const VisualizerIndividual = styled.div`
  display: flex;
`;

export const DirectionalButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;

  width: calc(100% - 200px);

  align-items: center;
  justify-content: space-between;

  padding: 0px 100px;

  position: absolute;

  top: 376px;
  left: 0;

`;

interface DirectionalButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    direction: 'left' | 'right';
  }

  export const DirectionalButton = styled.button<DirectionalButtonProps>`
      display: flex;

      visibility: ${({disabled}) => disabled ? 'hidden ' : 'visible'};

      align-items: center;
      justify-content: center;

      width: 40px;
      height: 40px;

      border: 1px solid ${NEUTRAL_COLORS.GRAY};
      border-radius: 69px;

      transform: ${({direction}) => direction === 'right' ? 'rotate(180deg)' : 'rotate(0deg)'};

      background-color: transparent;

      cursor: pointer;

      img{
        width: 24px;
        height: 24px;
      }
  `;

export const TotalImagesVisualizer = styled.div`
display: flex;
flex-direction: row;

margin-top: 16px;

p{
  color: ${NEUTRAL_COLORS.GRAY};
  font-size: ${FONT_SIZE.TINY};
  font-weight: ${FONT_WEIGTH.MEDIUM};
  line-height: 140%;
}
`;

export const ImageVisualizer = styled.img`
  object-fit: cover;
  width: 960px;
  height: 540px;
`;
